import instance from './instance'

const dealerPriceListUrl = 'modules-coupon/dealer-price-lists'

export const getDealerPriceListList = (page: number, pageSize: number, filterKey: any) =>
  instance.get(`${dealerPriceListUrl}?page=${page}&pageSize=${pageSize}&filterkey=${filterKey}`)

export const getDealerPriceListById = (id: number) => instance.get(`${dealerPriceListUrl}/${id}`)

export const createDealerPriceList = (payload: any) => instance.post(dealerPriceListUrl, payload)

export const updateDealerPriceList = (id: number, payload: any) =>
  instance.post(`${dealerPriceListUrl}/${id}`, payload)

export const deleteDealerPriceList = async (id: number) => await instance.delete(`${dealerPriceListUrl}/${id}`)

